export const STATUS_TYPES = {
  SUCCESS: 'success',
  FAILED: 'failure',
};

export const STATUS_CLASSTYPES = {
  SUCCESS: 'active',
  FAILED: 'returned',
};

export const CONFIG_CONST = {
  SCHEMA: 'schema'
};
